import { render, staticRenderFns } from "./FeaturedVendorTag.vue?vue&type=template&id=cedb923e&functional=true"
import script from "./FeaturedVendorTag.vue?vue&type=script&lang=js"
export * from "./FeaturedVendorTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports